// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React, { useEffect } from 'react';

import { removeToken } from '../../lib/localStorageHandler';
import config from '../../../config';

const Signout = () => {
  useEffect(() => {
    removeToken();
    // Force reload (to clear the redux state)
    window.location.href = `${config.appBaseUrl}/#/signin`;
  }, []);

  return null;
};

export default Signout;
